module.exports = __webpack_public_path__ + "img/listas_icon.8520e00a.png";